// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3mcuu","approved":"Status_approved__rEDY0","rejected":"Status_rejected__UI_kO","expired":"Status_expired__24nUd","label":"Status_label__1Uf6g"};